import { SET_PROCEDURES } from "../actions/ProcedureActions";

const initialState = {
    procedures: [],
};

const ProcedureReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROCEDURES:
      return {
        ...state,
        procedures: action.payload,
      };

    default:
      return state;
  }
};

export default ProcedureReducer;
